import { useEsiteCtx } from 'services/esite/context';
import { useGetDealerInfoQuery } from 'services/dealer/use-get-dealer-info-query';
import { useState } from 'react';

const useGetDealerInfo = () => {
  const { locale } = useEsiteCtx();
  const [storeId, setStoreId] = useState('');

  // isPending now is isLoading
  // react query doc:
  // https://tanstack.com/query/latest/docs/framework/react/guides/migrating-to-v5
  const { data, isPending, isError } = useGetDealerInfoQuery({
    storeId,
    locale
  });

  return {
    data,
    getDealerInfo: setStoreId,
    isLoading: isPending,
    isError
  };
};

export default useGetDealerInfo;
